(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["jf-product-tags"] && !Shopify.designMode) return;
  try {
    // Live price-per-serving.js contract: the pill tracks the selected purchase option (subscription
  // price, else one-time). The price is the selected variant's own (the per-variant map the block
  // renders); the Recharge widget, when mounted, supplies only the subscription discount as a ratio
  // of its two displayed prices, because it re-renders for a new variant after the switch event
  // settles and its absolute prices would still be the previous variant's. Without the widget the
  // subscription price is 90 % of the variant's.
  window.addEventListener('load', () => {
    const servingTag = document.querySelector('[data-serving-price]');
    if (!servingTag) return;
    const formatter = import('@theme/money-formatting');
    const { currency } = servingTag.dataset;
    // The format as text: the template's content is parsed, so its entities are decoded and its tags dropped.
    const moneyFormat = document.querySelector('template[data-serving-money-format]')?.content.textContent ?? '';

    let variantsInfo = {};
    try {
      variantsInfo = JSON.parse(servingTag.dataset.variantServings || '{}');
    } catch (error) {
      variantsInfo = {};
    }
    const servingInfo = servingTag.dataset.servings || '';
    const servingsMatch = servingInfo.match(/\d+/);
    const initial = variantsInfo[servingTag.dataset.variantId] || {};
    let current = { servings: initial.servings || (servingsMatch ? parseInt(servingsMatch[0], 10) : null), price: initial.price ?? null };
    if (!current.servings) return;

    const parsePrice = (el) => {
      if (!el) return null;
      return parseFloat(el.textContent.replace(/[^0-9.]/g, ''));
    };

    const getRechargePrice = (isSubscription) => {
      const widget = document.querySelector('recharge-subscription-widget');
      const root = widget?.shadowRoot;
      if (!root) return null;

      if (isSubscription) {
        const el = root.querySelector(
          '.rc-purchase-option__subscription .rc-price:not(.strike-through)'
        );
        return parsePrice(el);
      }
      const el = root.querySelector('.rc-selection__onetime .rc-price');
      return parsePrice(el);
    };

    const getShopifyPrice = () => {
      const cents = current.price ?? window.ShopifyAnalytics?.meta?.product?.variants?.[0]?.price ?? 0;
      return cents / 100;
    };

    const getSubscriptionRatio = () => {
      const subscription = getRechargePrice(true);
      const oneTime = getRechargePrice(false);
      return subscription && oneTime ? subscription / oneTime : 0.9;
    };

    // The amount is taken when the update is asked for, so updates waiting on the formatter's import
    // land in the order they were asked, and the last one (a variant switch) stands.
    const updateServingPrice = async (isSubscription) => {
      let price = getShopifyPrice();
      if (isSubscription) {
        price = price * getSubscriptionRatio();
      }
      if (!price || !current.servings || !moneyFormat) return;

      const servings = current.servings;
      const { convertMoneyToMinorUnits, formatMoney, getCurrencyPrecision } = await formatter;
      const decimals = getCurrencyPrecision(currency);
      let perServing = price / servings;
      const minor = price * 10 ** decimals;
      if (isSubscription && Math.abs(minor - Math.round(minor)) < 1e-6) {
        // The ratio gives back a whole price but for float error (¥1,995 reads 1994.9999…): take that price in minor
        // units and round its share per serving half up in integers. A price the ratio only comes near (after a variant
        // switch Recharge may still show the last variant's prices) keeps the ratio's own amount.
        perServing = Math.floor((2 * Math.round(minor) + servings) / (2 * servings)) / 10 ** decimals;
      }
      // Rounded in major units to the currency's decimals, as the pill always rounded, then read back
      // as the minor units formatMoney takes.
      const amount = convertMoneyToMinorUnits(perServing.toFixed(decimals), currency);
      servingTag.textContent = `${formatMoney(amount, moneyFormat, currency)} PER SERVING`;
    };

    const widget = document.querySelector('recharge-subscription-widget');
    const root = widget?.shadowRoot;
    const isSubscriptionSelected = () =>
      root?.querySelector('.rc-purchase-option__input:checked')?.value === 'subscription';
    updateServingPrice(isSubscriptionSelected());

    // The standard product-select event settles with the resolved variant (id + price): switch
    // the pill to that variant's servings and price.
    document.addEventListener('shopify:product:select', (event) => {
      event.promise
        ?.then(({ detail }) => {
          const variant = detail?.resource;
          const info = variant?.id != null ? variantsInfo[String(variant.id)] : null;
          if (!info) return;
          current = { servings: info.servings, price: variant.price ?? info.price };
          updateServingPrice(isSubscriptionSelected());
        })
        .catch(() => {});
    });

    if (!root) return;
    root.querySelectorAll('.rc-purchase-option__input').forEach((input) => {
      input.addEventListener('change', (e) => {
        updateServingPrice(e.target.value === 'subscription');
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
